import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'
import {
    Chip,
    Typography
} from '@material-ui/core'
import { useParams } from '../../utils/Hooks'
import { UrlManipulation } from '../../utils'

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        margin: 0,
    },
    chip: {
        margin: theme.spacing(0.3),
        color: theme.palette.primary.main
    },
}))

const ActiveFilterChips = () => {
    const classes = useStyles()
    const { t } = useTranslation()
    const params = useParams()

    const paramsToChips = () => {
        const chips = [
            ...params.deed_type.map(deed_type => ({
                label: t(`filters.valueMappings.${deed_type}`),
                key: deed_type,
            })),
            ...params.deed_land_register_divisions_region.map(region => ({
                label: t(`filters.valueMappings.${region}`),
                key: region,
            })),
            ...params.clause_lang.map(clause_lang => ({
                label: t(`filters.valueMappings.${clause_lang}`),
                key: clause_lang,
            })),
            ...params.region.map(region => ({
                label: t(`filters.valueMappings.${region}`),
                key: region,
            })),
        ]

        const yearObj = params.year.length === 2 && {
            label: `${params.year[0]}-${params.year[1]}`,
            key: 'year',
        }

        if (yearObj) chips.splice(1, 0, yearObj)

        if (params.subsection) chips.push({
            label: t(`filters.valueMappings.${params.subsection}`),
            key: 'subsection',
        })

        return chips
    }

    const chipData = paramsToChips()

    const handleDelete = (chipToDelete) => () => {
        UrlManipulation.goToSearch({
            deed_land_register_divisions_region: params.deed_land_register_divisions_region.filter(param => param !== chipToDelete.key),
            clause_lang: params.clause_lang.filter(param => param !== chipToDelete.key),
            deed_type: params.deed_type.filter(param => param !== chipToDelete.key),
            region: params.region.filter(param => param !== chipToDelete.key),
            year: chipToDelete.key === 'year' ? [] : params.year,
            subsection: chipToDelete.key === 'subsection' ? null : params.subsection,
            page: 1,
        })
    }

    const handleDeleteAll = () => {
        UrlManipulation.goToSearch({
            deed_land_register_divisions_region: null,
            clause_lang: null,
            deed_type: null,
            region: null,
            year: null,
            subsection: null,
            page: 1,
        })
    }

    return <div className={classes.root}>
        {chipData.length > 0 &&
            <React.Fragment>

                <Typography variant="body2" component="p">{t('filters.active')}</Typography>
                <Chip
                    label={t('filters.clear')}
                    onDelete={handleDeleteAll}
                    color="primary"
                    variant="outlined"
                    className={classes.chip}
                />
                {chipData.map(data => (
                    <Chip
                        key={data.key}
                        label={data.label}
                        onDelete={handleDelete(data)}
                        color="primary"
                        variant="outlined"
                        className={classes.chip}
                    />
                ))}

            </React.Fragment>
        }
    </div>
}

export default ActiveFilterChips